export default "__VITE_ASSET__CuW_sAKv__"